import { orderStore, setOrderStore } from '@store/orders/store';
import { TabState } from '@store/orders/types';
import {
  DraftVendorFormState,
  VendorContractViewModel,
} from '@typeDefinitions/vendorTypes';
import { produce } from 'solid-js/store';

import { setActiveCarrierTab } from './carrierActions';

export const removeVendorFromOrder = (vendorIndex: number) => {
  setOrderStore(
    'order',
    'vendors',
    produce((vendors) => {
      vendors?.splice(vendorIndex, 1);
    }),
  );
  setActiveCarrierTab({ index: 0, type: 'load' } as TabState);
};

export const setVendorToVoid = (vendorIndex: number) => {
  setOrderStore(
    'order',
    'vendors',
    produce((vendors) => {
      if (!vendors?.[vendorIndex]) return;
      vendors[vendorIndex].status = 'Void';
      // already voided server side, so it must not be resent on the next save
      vendors[vendorIndex].operationType = 'None';
    }),
  );
};

export const addNewVendorToOrder = (vendor: VendorContractViewModel) => {
  setOrderStore('order', 'vendors', (vendors) => [...(vendors || []), vendor]);
};

export const updateVendorPropertyAtIndex = (
  propertiesToUpdate: Partial<VendorContractViewModel>,
  idx?: number,
) => {
  setOrderStore(
    'order',
    'vendors',
    produce((vendors) => {
      if (!vendors) return;
      const index = idx ?? orderStore.activeTab.index;
      if (!vendors[index]) return;
      for (const property in propertiesToUpdate) {
        if (propertiesToUpdate.hasOwnProperty(property)) {
          const value =
            propertiesToUpdate[property as keyof VendorContractViewModel];
          if (['string', 'number', 'boolean'].includes(typeof value)) {
            if (vendors[index].operationType === 'None') {
              vendors[index].operationType = 'Update';
            }
          }
          (vendors[index] as unknown as Record<string, unknown>)[property] =
            value;
        }
      }
    }),
  );
};

export const updateVendorDraftFormState = (
  updates: Partial<DraftVendorFormState>,
  idx?: number,
) => {
  setOrderStore(
    'order',
    'vendors',
    produce((vendors) => {
      if (!vendors) return;
      const index = idx ?? orderStore.activeTab.index;
      if (!vendors[index]) return;
      vendors[index].draftFormState = {
        ...vendors[index].draftFormState,
        ...updates,
      };
    }),
  );
};

export const clearVendorDraftFormState = (idx?: number) => {
  setOrderStore(
    'order',
    'vendors',
    produce((vendors) => {
      if (!vendors) return;
      const index = idx ?? orderStore.activeTab.index;
      if (!vendors[index]) return;
      vendors[index].draftFormState = null;
    }),
  );
};
